// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"38bba411","649":"71b29447"}[chunkId] + ".chunk.css";
};